import Sticky from './Sticky';
import Drupal from './Drupal';
import Header from './Header';
import Toolbar from './Toolbar';
import HomeHero from './HomeHero';
import Navigation from './Navigation';
import DDTemplates from './DDTemplates';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import RelocateHeaderlinks from './RelocateHeaderlinks';
import RelocateSocial from './RelocateSocial';
import TwitterFeed from './TwitterFeed';
import TwitterSlider from './TwitterSlider';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import BackgroundImage from './BackgroundImage';
import BrowserCheck from './BrowserCheck';
import HomeNews from './HomeNews';
import Visible from './Visible';
import StringSplit from './StringSplit';
import HomeFeatured from './HomeFeatured';

// Add the theme behaviors
Drupal.behavior(() => {
  // Body element
  const body = document.body;
  // Page element
  const page = document.querySelector('.page');

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Get browser and version
  if (body && !body.browserCheck) {
    body.browserCheck = new BrowserCheck(body);
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  const mainMenu = document.querySelector('#nice-menu-3');
  if (mainMenu && !mainMenu.Navigation) {
    mainMenu.Navigation = new Navigation(mainMenu);
  }

  // Controls the states of the menu and search states
  const toolbar = document.querySelector('.toolbar');
  if (toolbar && !toolbar.Toolbar) {
    toolbar.Toolbar = new Toolbar(toolbar);
  }

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Wraps each accordion element
  document.querySelectorAll('.accordion-heading').forEach((element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  document.querySelectorAll('.node-content').forEach((element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Relocate headerlinks based on media query
  const headerlinks = document.querySelector('.headerlinks');
  if (headerlinks && !headerlinks.relocate) {
    headerlinks.relocate = new RelocateHeaderlinks(headerlinks);
  }

  // Relocate header social links based on media query
  const headerSocialLinks = document.querySelector('.header-social-links');
  if (headerSocialLinks && !headerSocialLinks.relocate) {
    headerSocialLinks.relocate = new RelocateSocial(headerSocialLinks);
  }

  // Twitter Feed
  const twitter = document.querySelector('.twitter-feed');
  if (twitter && !twitter.Feed && !twitter.Slider) {
    twitter.Feed = new TwitterFeed(twitter);
    setTimeout(() => {
      twitter.Slider = new TwitterSlider(twitter);
    }, 1000);
  }

  // Term Navigation
  const termNavigation = document.querySelector('.term-navigation');
  if (termNavigation && !termNavigation.TermNavigation) {
    termNavigation.TermNavigation = new TermNavigation(termNavigation);
  }

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Banner
  document.querySelectorAll('.banner').forEach((banner) => {
    if (!banner.BgImage) {
      banner.BgImage = new BackgroundImage(banner, {
        sourceSelector: 'figure img',
        destSelector: '.node-banner',
      });
    }
  });

  // =============================================================================
  // HOME PAGE FUNCTIONALITY
  // =============================================================================

  // Home Hero Block
  let block = document.querySelector('.home-hero.block');
  if (block && !block.HomeHero && !block.BgImage && !block.visible) {
    block.HomeHero = new HomeHero(block);
    block.BgImage = new BackgroundImage(block, {
      sourceSelector: 'figure img',
      destSelector: 'figure',
    });
    block.visible = new Visible(block);
  }

  // Homepage News and Events
  block = document.querySelector('.home-news');
  if (block && !block.homeNews && !block.visible) {
    block.homeNews = new HomeNews(block);
    block.visible = new Visible(block);
  }

  // Homepage News and Events
  block = document.querySelector('.home-featured');
  if (block && !block.homeFeatured && !block.visible) {
    block.homeFeatured = new HomeFeatured(block);
    block.visible = new Visible(block);
  }

  // =============================================================================
  // FOOTER
  // =============================================================================

  // Smart Footer
  const footer = document.querySelector('.page-footer');
  if (footer && !footer.SmartFooter && page) {
    footer.SmartFooter = new SmartFooter(footer, page);
  }
});
